import { ConnectedPosition } from '@angular/cdk/overlay';

/**
 * Default overlay order for pop-up menus: below trigger with edges aligned to the end (right in LTR),
 * then above, then fall back to start-aligned pairs (CDK-style).
 */
export const PS_DROPDOWN_BELOW_END_POSITIONS: ConnectedPosition[] = [
  { originX: 'end', originY: 'bottom', overlayX: 'end', overlayY: 'top' },
  { originX: 'end', originY: 'top', overlayX: 'end', overlayY: 'bottom' },
  { originX: 'start', originY: 'bottom', overlayX: 'start', overlayY: 'top' },
  { originX: 'start', originY: 'top', overlayX: 'start', overlayY: 'bottom' },
];

export const PS_DROPDOWN_BELOW_START_POSITIONS: ConnectedPosition[] = [
  { originX: 'start', originY: 'bottom', overlayX: 'start', overlayY: 'top' },
  { originX: 'start', originY: 'top', overlayX: 'start', overlayY: 'bottom' },
  { originX: 'end', originY: 'bottom', overlayX: 'end', overlayY: 'top' },
  { originX: 'end', originY: 'top', overlayX: 'end', overlayY: 'bottom' },
];

/** Preferred menu positions for triggers: below-end strategies, then below-start (CDK tries in order). */
export const PS_DROPDOWN_MENU_POSITIONS: ConnectedPosition[] = [
  ...PS_DROPDOWN_BELOW_END_POSITIONS,
  ...PS_DROPDOWN_BELOW_START_POSITIONS,
];
